var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOcr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "evenodd",
    d: "M9.75.75A.75.75 0 0 1 10.5 0h1.75C13.216 0 14 .784 14 1.75V3.5a.75.75 0 0 1-1.5 0V1.75a.25.25 0 0 0-.25-.25H10.5a.75.75 0 0 1-.75-.75M0 7a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 7m1.5-5.25a.25.25 0 0 1 .25-.25H3.5a.75.75 0 0 0 0-1.5H1.75A1.75 1.75 0 0 0 0 1.75V3.5a.75.75 0 0 0 1.5 0zm11.75 8a.75.75 0 0 1 .75.75v1.75A1.75 1.75 0 0 1 12.25 14H10.5a.75.75 0 0 1 0-1.5h1.75a.25.25 0 0 0 .25-.25V10.5a.75.75 0 0 1 .75-.75M1.5 10.5a.75.75 0 0 0-1.5 0v1.75C0 13.216.784 14 1.75 14H3.5a.75.75 0 0 0 0-1.5H1.75a.25.25 0 0 1-.25-.25z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcr);
export default __webpack_public_path__ + "static/media/ocr.6ab63c7ae8f2cbf5c2018f3c4e0bb75d.svg";
export { ForwardRef as ReactComponent };